import { Modal } from "@app/components";
import { Button } from "@app/controls";
import type { RootState } from "@app/redux";
import React from "react";
import { useSelector } from "react-redux";
import messages from "./messages";
import "./new-client-disclaimer-modal.css";
import type { Properties } from "./properties";

export const NewClientDisclaimerModalView = (props: Properties) => {
	const { language } = useSelector((state: RootState) => state.language);

	return (
		<Modal
			className="new-client-disclaimer-modal w-full h-full flex flex-col items-center"
			overlayColor="light"
			open={props.open}
			onClose={props.onClose}
			onCloseTransitionEnd={props.onCloseTransitionEnd}
		>
			<div className="new-client-disclaimer-container">
				<div className="heading mb-10">
					<h2 className="mb-5">{messages[language].header}</h2>
					<div className="heading-underline" />
				</div>
				<div
					className="my-9.5"
					dangerouslySetInnerHTML={{
						__html: messages[language].body,
					}}
				></div>
				<Button
					className="proceed-button mx-auto"
					type="button"
					theme="primary"
					onClick={props.onProceed}
				>
					{messages[language].proceed}
				</Button>
			</div>
		</Modal>
	);
};
